<script setup>
import { useLayout } from '@/layout/composables/layout';
import { computed, ref, watch } from 'vue';
import AppSidebar from './AppSidebar.vue';
import NotificationManager from '@/components/NotificationManager.vue';

const { layoutConfig, layoutState, isSidebarActive, toggleMenu } = useLayout();
const outsideClickListener = ref(null);

watch(isSidebarActive, (newVal) => {
    if (newVal) {
        bindOutsideClickListener();
    } else {
        unbindOutsideClickListener();
    }
});

const containerClass = computed(() => {
    return {
        'layout-overlay': layoutConfig.menuMode === 'overlay',
        'layout-static': layoutConfig.menuMode === 'static',
        'layout-static-inactive': layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
        'layout-overlay-active': layoutState.overlayMenuActive,
        'layout-mobile-active': layoutState.staticMenuMobileActive,
        'sidebar-collapsed': layoutState.sidebarCollapsed
    };
});

function bindOutsideClickListener() {
    if (!outsideClickListener.value) {
        outsideClickListener.value = (event) => {
            try {
                if (isOutsideClicked(event)) {
                    layoutState.overlayMenuActive = false;
                    layoutState.staticMenuMobileActive = false;
                    layoutState.menuHoverActive = false;
                }
            } catch (error) {
                globalThis.clientLogger?.warn('Error in outside click listener:', error);
            }
        };
        document.addEventListener('click', outsideClickListener.value);
    }
}

function unbindOutsideClickListener() {
    if (outsideClickListener.value) {
        document.removeEventListener('click', outsideClickListener.value);
        outsideClickListener.value = null;
    }
}

function isOutsideClicked(event) {
    // Check if event and target exist
    if (!event || !event.target) {
        return false;
    }

    const sidebarEl = document.querySelector('.layout-sidebar-new');
    const topbarEl = document.querySelector('.layout-menu-button');

    // Check if elements exist and if the click is outside
    const isOutsideSidebar = !sidebarEl || (!sidebarEl.isSameNode(event.target) && !sidebarEl.contains(event.target));
    const isOutsideTopbar = !topbarEl || (!topbarEl.isSameNode(event.target) && !topbarEl.contains(event.target));

    return isOutsideSidebar && isOutsideTopbar;
}
</script>

<template>
    <div class="layout-wrapper page-bg" :class="containerClass">
        <!-- Mobile Menu Button -->
        <button
            class="mobile-menu-button layout-menu-button"
            @click="toggleMenu"
            v-show="layoutConfig.menuMode === 'overlay'"
        >
            <div class="mobile-menu-icon">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </button>

        <app-sidebar></app-sidebar>
        
        <div class="layout-main-container">
            <div class="layout-main">
                <router-view></router-view>
            </div>
        </div>
        <div class="layout-mask animate-fadein"></div>
    </div>
    <NotificationManager />
</template>

<style lang="scss" scoped>
</style>
